<template>
  <workbenchDetail
    @cancelCallBack="cancel"
    @approvalConfirm="approvalConfirm"
    :backlogModel="backlogModel"
    :isHide="isHide"
  >
    <div slot="content">
      <el-form label-width="120px" :model="dataForm">
        <el-form-item label="项目编号：">
          {{ dataForm.ProjectCode }}
        </el-form-item>
        <el-form-item label="项目名称：">
          {{ dataForm.ProjectName }}
        </el-form-item>
        <el-form-item label="是否求助项目：">
          {{ showIsHelp(dataForm.IsHelp) }}
        </el-form-item>
        <el-form-item label="是否接受捐赠：">
          {{ showIsDonation(dataForm.IsDonation) }}
        </el-form-item>
        <el-form-item label="项目类型：">
          {{ dataForm.ProjectType }}
        </el-form-item>
        <el-form-item label="项目归属：">
          {{ dataForm.TeamName }}
        </el-form-item>
        <el-form-item label="项目截止时间：">
          <p v-if="dataForm.EndTime">
            {{ (dataForm.EndTime * 1000) | formatDate }}
          </p>
          <p v-else>长期</p></el-form-item
        >
        <el-form-item label="封面图：" v-if="dataForm.CoverMap">
          <of-upload
            class="upload-demo"
            list-type="picture-card"
            @onPreview="onPreview"
            :fileList="pictureList"
            :class="{ hide: true }"
          >
            <div slot="content">
              <i slot="default" class="el-icon-plus"></i>
            </div>
          </of-upload>
          <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <el-form-item label="附件：" v-if="dataForm.File">
          <el-upload
            class="upload-demo"
            action="/api/File/FileUpload"
            :on-preview="onFilePreview"
            :file-list="fileList"
          >
          </el-upload>
        </el-form-item>
        <el-form-item label="摘要：">
          {{ dataForm.Abstract }}
        </el-form-item>
        <el-form-item label="项目介绍：">
          <of-tinymce
            v-model="dataForm.Describe"
            :height="500"
            :isEdit="true"
          ></of-tinymce>
        </el-form-item>
      </el-form>
    </div>
  </workbenchDetail>
</template>
<script>
import workbenchDetail from "@/modules/zjrc/pages/workbench/common/workbenchDetail";
import OfUpload from "@/components/controls/of_upload/of_upload";
import OfTinymce from "@/components/controls/of_editor/of_tinymce_readonly";
import api from "@/modules/zjrc/api";
import { saveAs } from "file-saver";
import { mapGetters } from "vuex";

export default {
  name: "audit",
  props: {
    backlogModel: {
      type: Object,
      default: null,
    },
    isHide:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      dataForm: {}, //表单对象
      dialogVisible: false,
      dialogImageUrl: "",
      pictureList:[],//图片数组
      fileList:[]
    };
  },
  components: {
    workbenchDetail,
    OfUpload,
    OfTinymce,
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
    showIsHelp(data) {
      return (data) => {
        return data ? "是" : "否";
      };
    },
    showIsDonation(data) {
      return (data) => {
        return data ? "是" : "否";
      };
    },
  },
  mounted() {
    let that = this;
    that.loadData();
  },
  methods: {
    //初始化数据
    loadData() {
      let that = this;
      let params = { Id: that.backlogModel.BusinessId };
      api.QueryPublicWelfareById(params).then((res) => {
        if (res.data.Code == 0) {
          that.dataForm = res.data.Data;
          that.getImg();
          that.getlistfile();
        }
      });
    },
    //取消
    cancel() {
      this.$emit("auditCallBack", null);
    },
    //提交数据
    approvalConfirm(data) {
      let params = Object.assign({}, data);
      api
        .AuditPublicWelfare(params)
        .then((res) => {
          if (res.data.Code === 0) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.$emit("auditCallBack", params);
          } else {
            this.$message({
              message: res.data.Message,
              type: "error",
            });
          }
        })
        .catch((e) => {
          this.$message({
            message: e.toString(),
            type: "error",
          });
        });
    },
        //查看图片
    onPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    getImg() {
      const vm = this
      if (
        vm.dataForm.CoverMap === undefined ||
        vm.dataForm.CoverMap === null ||
        vm.dataForm.CoverMap == ""
      ) {
        return;
      }
      const obj = JSON.parse(vm.dataForm.CoverMap)
      vm.pictureList.push(obj)
    },
     //加载文件
    getlistfile() {
      let that = this;
      if (that.dataForm.File || that.dataForm.File != null) {
        let params = { Id: that.dataForm.File };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              that.fileList.push({
                url: item.Url,
                name: item.FileName,
              });
            });
          }
        });
      }
    },
    //附件下载
    onFilePreview(file) {
      saveAs(file.url, file.name);
    },
  },
};
</script>

<style scoped>
.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}
.upload-demo >>> .el-upload-list__item-delete {
  display: none !important;
}
.upload-demo >>> .el-icon-close {
  display: none !important;
}
.upload-demo >>> .el-icon-close-tip {
  display: none !important;
}
.upload-demo>>>.el-upload--text{
  display: none !important;
}
</style>

<style>
.hidePic .el-upload--picture-card {
  display: none !important;
}

.hideFile .el-upload--fileList {
  display: none !important;
}
</style>